import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Platform } from '@ionic/angular';
import { TshirtStyle, TshirtType } from '../../services/lineup-service';

@Component({
  standalone:true,
  selector: 'svg-tshirt-container',
  templateUrl: 'svg-tshirt-container.html',
  styleUrls:['./svg-tshirt-container.scss']
})
export class SvgTshirtContainerComponent {
  @Input() style$: TshirtStyle;
  @Input() type$: TshirtType;

  constructor(private platform: Platform) { }

  public get style(): typeof TshirtStyle {
    return TshirtStyle;
  }

  public get type(): typeof TshirtType {
    return TshirtType;
  }
}